export class WebFormsUtility {
    public static get pageRequestManager() {
        return window.Sys.WebForms.PageRequestManager.getInstance();
    }

    private static requestsNameToCallback: { [key: string]: (sender: any, args: any) => void } = {};

    public static addBeginRequest(callback: (sender: Telerik.Web.UI.RadWindow, args: Sys.WebForms.BeginRequestEventArgs) => void, name: string = "genericBegin") {
        this.removeRequest("beginRequest", name);
        this.pageRequestManager.add_beginRequest(callback);
        this.requestsNameToCallback[name] = callback;
    }

    public static addEndRequest(callback: (sender: Telerik.Web.UI.RadWindow, args: Sys.WebForms.EndRequestEventArgs) => void, name: string = "genericEnd") {
        this.removeRequest("endRequest", name);
        this.pageRequestManager.add_endRequest(callback);
        this.requestsNameToCallback[name] = callback;
    }

    public static removeRequest(requestType: string, name: string) {
        let callback = this.requestsNameToCallback[name];
        if (callback != null) {
            this.pageRequestManager["remove_"+requestType](callback);
            this.requestsNameToCallback[name] = null;
        }
    }
}